<template>
  <div>
    
    <Modal :open="true" @close="$emit('close')">
      
      <div class="aboutus-wrapper">
          <div class="aboutus-inner p-4">
          <h2><i @click="$emit('close')" class="fa fa-times"> </i></h2>

            <div class="convertor-demo">

              <div class="row" style="height:100%;">
                <div class="col-md-12 col-sm-12" style="
                display:flex;
                align-items:center;
                padding: 0 16px;
                ">

                  
                  <div class="convertor-demo-wrapper">
                    <h4 class="pt-2 text-center t2-c">
                      ماشین حساب
                    </h4>
                    <div class="d-flex ">
                      <div style="width:50%;padding-left : 5px;padding-bottom:8px;">
                        <button class="--btn --btn-sm --btn-block"
                          :class="[ exchangeType ? '--btn-theme' : '--btn-empty']"
                          @click="exchangeType = true">خرید از ما</button>
                      </div>
                      <div style="width:50%;padding-right : 5px;padding-bottom:8px;">
                        <button class="--btn --btn-sm --btn-block"
                          :class="[ !exchangeType ? '--btn-theme' : '--btn-empty']"
                          @click="exchangeType = false">فروش به ما</button>
                      </div>
                    </div>
                    
                    <template v-if="exchangeType">
                      <div class="convertor-demo-input-wrapper">

                        <div class="symbol mb-3">
                          <span class="symbol-icon">
                            <span>
                              <img class="mr-1" :src="StaticImageUrl+'assets/images/irflag.png'" alt="">
                            </span>
                            <span class="symbol-name mr-1">
                              تومان
                            </span>
                          </span>
                        </div>
                        <div class="input">
                          <input v-model="buy_amount" step="1000" min="0" type="number" id="amount" :placeholder="'مقدار تومان را وارد کنید'">
                        </div>
                      </div>

                      <div class="text-center my-4">
                        <img class="conv-img" :src="StaticImageUrl+'assets/images/site-icons/chevron_down.svg'" alt="">
                      </div>

                      <div class="convertor-demo-input-wrapper">
                        <div class="symbol mb-3">
                          <span class="symbol-icon">
                            <img class="mr-1" :src="StaticImageUrl+'assets/images/icon/USDT.png'" alt="">
                            <span class="symbol-name mr-1">{{to_persian["USDT"]}}</span>
                          </span>
                        </div>
                        <div class="input">
                          <div class="my-3 text-center mx-4" style="color:#5e5e5e;" v-if="!buy_crypto_recieve">مقدار دریافتی (تقریبی)</div>
                          <div class="my-3 text-center mx-4 text-dark" v-else>
                            {{buy_crypto_recieve}} ≊
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-else>
                      <div class="convertor-demo-input-wrapper">

                        <div @click="crypto_modal = true" class="symbol mb-3">
                          <span class="symbol-icon">
                            <img class="mr-1" :src="this.StaticImageUrl+'assets/images/icon/'+crypto.symbol+'.png'" alt="">
                            <span class="symbol-name mr-1">{{to_persian[crypto.symbol]}}</span>
                          </span>
                          <span class="fa fa-angle-down ml-2 caret"></span>
                        </div>

                        <div class="input">
                          <input @keypress="just_float($event)" type="number" v-model="amount" id="amount">
                        </div>
                      </div>

                      <div class="text-center my-4">
                        <img class="conv-img" :src="StaticImageUrl+'assets/images/site-icons/chevron_down.svg'" alt="">
                      </div>

                      <div class="convertor-demo-input-wrapper">
                        
                        <div class="symbol mb-3">
                          <span class="symbol-icon">
                            <span>
                              <img class="mr-1" :src="this.StaticImageUrl+'assets/images/irflag.png'" alt="">
                            </span>
                            <span class="symbol-name mr-1">
                              تومان
                            </span>
                          </span>
                        </div>
                        <div class="input">
                          <div class="my-3 text-center mx-4" style="color:#5e5e5e;" v-if="!toman_recieve">مقدار دریافتی (تقریبی)</div>
                          <div class="my-3 text-center mx-4 text-dark" v-else>
                          {{ formatPrice(toman_recieve) }}
                          ≊</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

            </div>

          </div>
      </div>
    </Modal>
    
    <modal @close="coin_modal = false" :open="coin_modal" :maxWitdh="'400px'">
      <div class="bg-fff">
        <div @click="coin_modal = false , convert = true" class="row convertor-crypto">
          <div class="col-4">
            <img width="35px" :src="StaticImageUrl+'assets/images/tether-png.png'" alt="">
          </div>
          <div class="col-8">
            <div class="box-item">
              <div class="prsIcon">تتر</div>
            </div>
          </div>
        </div>
        <div @click="coin_modal = false , convert = false" class="row convertor-crypto">
          <div class="col-4">
            <img width="35px" :src="StaticImageUrl+'assets/images/irflag.png'" alt="">
          </div>
          <div class="col-8">
            <div class="box-item">
              <div class="prsIcon">تومان</div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal @close="crypto_modal = false" :open="crypto_modal" :maxWitdh="'600px'">
      <div class="card">
        <div class="card-header text-dark">
          لطفا ارز مورد نظر خود را انتخاب کنید.
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" v-model="crypto_search" class="form-control" placeholder="جست و جو">
              </div>
            </div>
          </div>

          <div class="row convertor-crypto" @click="crypto = {
              symbol:'USDT',
              price: data.buy_price,
            } , crypto_modal = false">
              
            <div class="col-6">
              <div class="box-item">
                <div class="img-box"><img :src="StaticImageUrl+'assets/images/tether-png.png'" alt=""></div>
                <div class="coin-txt-box">
                  <div class="prsIcon">تتر</div>
                  <div class="engIcon">USDT</div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <p style="display:inline-block;"></p>
            </div>
          </div>
          <!-- <template v-if="!exchangeType"> -->
          <div v-for="(item , key) in crypto_list" :key="key">
            <template v-if="item.symbol.endsWith('USDT')">
              <template v-if="
                !item.symbol.endsWith('BULLUSDT') && 
                !item.symbol.endsWith('BEARUSDT') && 
                !item.symbol.endsWith('UPUSDT') && 
                !item.symbol.endsWith('DOWNUSDT')">
                <template v-if="item.symbol.includes(crypto_search)">
                  <div class="row convertor-crypto" @click="crypto = {
                    price:item.markPrice,
                    symbol:item.symbol
                  } , crypto_modal = false">
                    <div class="col-6">
                      <div class="box-item">
                        <div class="img-box"><img :src="'assets/images/icon/'+ item.symbol +'.png'" alt=""></div>
                        <div class="coin-txt-box">
                            <p class="prsIcon">{{to_persian[item.symbol]}}</p>
                            <p class="engIcon">{{item.symbol}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 text-center">
                      <p style="display:inline-block;">
                        <template v-if="convert">{{parseFloat(item.markPrice).toFixed(3)}} تتر</template>
                        <template v-if="!convert">{{formatPrice(Math.round(parseFloat(item.markPrice) * state_prices.buy_price))}} تومان</template>
                      </p>
                    </div>
                  </div>
                </template>
              </template>
            </template>
          </div>
          <!-- </template> -->
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from './Modal.vue'
import {TheMask} from 'vue-the-mask'
import {io} from 'socket.io-client';
export default {
  name: 'Convertor',
  components:{
    TheMask,
    Modal
  },
  data : () => ({
    exchangeType:true,
    convert:true,
    buy_amount:null,
    amount:null,
    crypto_modal:false,
    coin_modal:false,
    crypto_search:'',
    crypto_list:{},
    crypto:{},
    data:{},
    to_persian : {
      'IR' : 'تومان',
      'USDT' : 'تتر',
      'BTCUSDT' : 'بیت کوین',
      'ETHUSDT' : 'اتریوم',
      'BNBUSDT' : 'بایننس کوین',
      'BCCUSDT' : 'بیت کوین کش',
      'NEOUSDT' : 'نئو',
      'LTCUSDT' : 'لایت کوین',
      'QTUMUSDT' : 'کوانتوم',
      'ADAUSDT' : 'کاردانو',
      'XRPUSDT' : 'ریپل',
      'EOSUSDT' : 'ایاس',
      'TUSDUSDT' : 'ترو یو اس دی',
      'IOTAUSDT' : 'آیوتا',
      'XLMUSDT' : 'استلار',
      'ONTUSDT' : 'آنتولوژی',
      'TRXUSDT' : 'ترون',
      'ETCUSDT' : 'اتریوم کلایک',
      'ICXUSDT' : 'آیکون',
      'VENUSDT' : 'ویچین',
      'NULSUSDT' : 'نالز',
      'VETUSDT' : 'وی چین',
      'PAXUSDT' : 'پکسوز',
      'BCHABCUSDT' : 'بیت کوین کش abc',
      'BCHSVUSDT' : 'بیت کوین کش sv',
      'USDCUSDT' : 'یو اس دی کوین',
      'LINKUSDT' : 'چین لینک',
      'WAVESUSDT' : 'ویوز',
      'BTTUSDT' : 'بیت تورنت',
      'USDSUSDT' : 'استیبل',
      'ONGUSDT' : 'آنتولوژی گز',
      'HOTUSDT' : 'هولو',
      'ZILUSDT' : 'زیلیکا',
      'ZRXUSDT' : 'زیرو اکس',
      'FETUSDT' : 'فچ',
      'BATUSDT' : 'بیسیک اتنشن',
      'XMRUSDT' : 'مونرو',
      'ZECUSDT' : 'زی کش',
      'IOSTUSDT' : 'آی او اس تی',
      'CELRUSDT' : 'سلر نتورک',
      'DASHUSDT' : 'دش',
      'NANOUSDT' : 'نانو',
      'OMGUSDT' : 'اومیسی گو',
      'THETAUSDT' : 'تتا',
      'ENJUSDT' : 'انجین کوین',
      'MITHUSDT' : 'میتریل',
      'MATICUSDT' : 'متیک',
      'ATOMUSDT' : 'کاسموس',
      'TFUELUSDT' : 'تتا فیول',
      'ONEUSDT' : 'هارمونی',
      'FTMUSDT' : 'فانتوم',
      'ALGOUSDT' : 'الگوراند',
      'USDSBUSDT' : 'استیبل',
      'GTOUSDT' : 'گیفتو',
      'ERDUSDT' : 'الراند',
      'DOGEUSDT' : 'دوج کوین',
      'DUSKUSDT' : 'داسک',
      'ANKRUSDT' : 'انکر نتورک',
      'WINUSDT' : 'وینک',
      'COSUSDT' : 'کانتنت اواس',
      'NPXSUSDT' : '',
      'COCOSUSDT' : 'کوکوس',
      'MTLUSDT' : 'متال',
      'TOMOUSDT' : 'توموچین',
      'PERLUSDT' : 'پرلین',
      'DENTUSDT' : 'دنت',
      'MFTUSDT' : 'مین فریم',
      'KEYUSDT' : 'سلف کی',
      'STORMUSDT' : 'استورم',
      'DOCKUSDT' : 'داک',
      'WANUSDT' : 'ون چین',
      'FUNUSDT' : 'فان فیر',
      'CVCUSDT' : 'سیویک',
      'CHZUSDT' : 'چیلیر',
      'BANDUSDT' : 'باند پروتکل',
      'BUSDUSDT' : 'بایننس یو اس دی',
      'BEAMUSDT' : 'بیم',
      'XTZUSDT' : 'تزوس',
      'RENUSDT' : 'ریپابلبک توکن',
      'RVNUSDT' : 'ریون کوین',
      'HCUSDT' : 'هایپر کش',
      'HBARUSDT' : 'هدرا هشگراف',
      'NKNUSDT' : 'ان کی ان',
      'STXUSDT' : 'بلک استک',
      'KAVAUSDT' : 'کاوا',
      'ARPAUSDT' : 'آرپاچین',
      'IOTXUSDT' : 'آیوتکس',
      'RLCUSDT' : 'آی اکسز آر ال سی',
      'MCOUSDT' : 'ام سی او',
      'CTXCUSDT' : 'کورتکس',
      'BCHUSDT' : 'بیت کوین کش',
      'TROYUSDT' : 'تروی',
      'VITEUSDT' : 'وایت',
      'FTTUSDT' : 'اف تی ایکس',
      'EURUSDT' : '',
      'OGNUSDT' : 'اوریجین توکن',
      'DREPUSDT' : 'دی رپ',
      'BULLUSDT' : '',
      'BEARUSDT' : '',
      'ETHBULLUSDT' : '',
      'ETHBEARUSDT' : '',
      'TCTUSDT' : 'توکن کلاب',
      'WRXUSDT' : 'وزیر ایکس',
      'BTSUSDT' : 'بیت شرز',
      'LSKUSDT' : 'لیسک',
      'BNTUSDT' : 'بانکور',
      'LTOUSDT' : 'ال تی او نتورک',
      'EOSBULLUSDT' : '1',
      'EOSBEARUSDT' : '1',
      'XRPBULLUSDT' : '1',
      'XRPBEARUSDT' : '1',
      'STRATUSDT' : 'استراتیس',
      'AIONUSDT' : 'آئون',
      'MBLUSDT' : 'مووی بلاک',
      'COTIUSDT' : 'کوتی',
      'BNBBULLUSDT' : '1',
      'BNBBEARUSDT' : '1',
      'STPTUSDT' : 'اس تی پی نتورک',
      'WTCUSDT' : 'والتون',
      'DATAUSDT' : 'استریمر داتاکوین',
      'XZCUSDT' : 'فیرو',
      'SOLUSDT' : 'سولانا',
      'CTSIUSDT' : 'کارتزی',
      'HIVEUSDT' : 'هایو',
      'CHRUSDT' : 'کرومیا',
      'BTCUPUSDT' : '1',
      'BTCDOWNUSDT' : '1',
      'GXSUSDT' : 'جی ایکس چین',
      'ARDRUSDT' : 'آردور',
      'LENDUSDT' : 'آوی',
      'MDTUSDT' : 'مژربل دیتا توکن',
      'STMXUSDT' : 'استورم ایکس',
      'KNCUSDT' : 'کایبر نتورک',
      'REPUSDT' : 'آگور ورژن2',
      'LRCUSDT' : 'لوپرینک',
      'PNTUSDT' : 'پنتا',
      'COMPUSDT' : 'کامپوند',
      'BKRWUSDT' : '1',
      'SCUSDT' : 'سیا کوین',
      'ZENUSDT' : 'هایریزن',
      'SNXUSDT' : 'سینتیکس',
      'ETHUPUSDT' : '1',
      'ETHDOWNUSDT' : '1',
      'ADAUPUSDT' : '1',
      'ADADOWNUSDT' : '1',
      'LINKUPUSDT' : '1',
      'LINKDOWNUSDT' : '1',
      'VTHOUSDT' : 'وتور',
      'DGBUSDT' : 'دیجی بایت',
      'GBPUSDT' : '1',
      'SXPUSDT' : 'سوایپ',
      'MKRUSDT' : 'میکر',
      'DAIUSDT' : '1',
      'DCRUSDT' : 'دکرد',
      'STORJUSDT' : 'استورج',
      'BNBUPUSDT' : '1',
      'BNBDOWNUSDT' : '1',
      'XTZUPUSDT' : '1',
      'XTZDOWNUSDT' : '1',
      'MANAUSDT' : 'دی سنترلند',
      'AUDUSDT' : '1',
      'YFIUSDT' : 'یرن فایننس',
      'BALUSDT' : 'بالانسر',
      'BLZUSDT' : 'بلوزل',
      'IRISUSDT' : 'آی آر اس نت',
      'KMDUSDT' : 'کمودو',
      'JSTUSDT' : 'جاست',
      'ANTUSDT' : 'آراگون',
      'SRMUSDT' : 'سروم',
      'CRVUSDT' : 'کرو',
      'SANDUSDT' : 'سندباکس',
      'OCEANUSDT' : 'اوشن پروتکل',
      'NMRUSDT' : 'نوموریر',
      'DOTUSDT' : 'پولکادات',
      'LUNAUSDT' : 'ترا',
      'RSRUSDT' : 'ریزرو رایتس',
      'PAXGUSDT' : 'پکس گلد',
      'WNXMUSDT' : 'ریپد ان ایکس ام',
      'TRBUSDT' : 'تلور',
      'BZRXUSDT' : 'بی زد ایکس پروتکل',
      'SUSHIUSDT' : 'سوشی',
      'YFIIUSDT' : 'دی اف ای مانی',
      'KSMUSDT' : 'کوساما',
      'EGLDUSDT' : 'الراند گلد',
      'DIAUSDT' : 'دیا',
      'RUNEUSDT' : 'تورچین',
      'FIOUSDT' : 'اف آی او پروتکل',
      'UMAUSDT' : 'یو ام ای',
      'EOSUPUSDT' : '1',
      'EOSDOWNUSDT' : '1',
      'TRXUPUSDT' : '1',
      'TRXDOWNUSDT' : '1',
      'XRPUPUSDT' : '1',
      'XRPDOWNUSDT' : '1',
      'DOTUPUSDT' : '1',
      'DOTDOWNUSDT' : '1',
      'BELUSDT' : 'بلا پروتکل',
      'WINGUSDT' : 'وینگ پروتکل',
      'LTCUPUSDT' : '1',
      'LTCDOWNUSDT' : '1',
      'UNIUSDT' : 'یونی سواپ',
      'NBSUSDT' : 'نیو بیت شرز',
      'OXTUSDT' : 'ارکید',
      'SUNUSDT' : 'سان',
      'AVAXUSDT' : 'آولنج',
      'HNTUSDT' : 'هلیوم',
      'FLMUSDT' : 'فلامینگو',
      'UNIUPUSDT' : '1',
      'UNIDOWNUSDT' : '1',
      'ORNUSDT' : 'اوریون پروتکل',
      'UTKUSDT' : 'یوتراست',
      'XVSUSDT' : 'ونوس',
      'ALPHAUSDT' : 'آلفا فایننس لب',
      'AAVEUSDT' : 'آوی',
      'NEARUSDT' : 'نیر پروتکل',
      'SXPUPUSDT' : '1',
      'SXPDOWNUSDT' : '1',
      'FILUSDT' : 'فایل کوین',
      'FILUPUSDT' : '1',
      'FILDOWNUSDT' : '1',
      'YFIUPUSDT' : '1',
      'YFIDOWNUSDT' : '1',
      'INJUSDT' : 'اینجکتیو پروتکل',
      'AUDIOUSDT' : 'آدیوس',
      'CTKUSDT' : 'سرتیک',
      'BCHUPUSDT' : '1',
      'BCHDOWNUSDT' : '1',
      'AKROUSDT' : 'آکروپلیس',
      'AXSUSDT' : 'آکسی اینفینیتی',
      'HARDUSDT' : 'هارد پروتکل',
      'DNTUSDT' : 'دیستریکت زیرو ایکس',
      'STRAXUSDT' : 'استراتیس',
      'UNFIUSDT' : 'یونیفای پروتکل',
      'ROSEUSDT' : 'یو آیسیس نتورک',
      'AVAUSDT' : 'تراولا',
      'XEMUSDT' : 'نم',
      'AAVEUPUSDT' : '',
      'AAVEDOWNUSDT' : '',
      'SKLUSDT' : 'اسکیل نتورک',
      'SUSDUSDT' : 'اس یو اس دی',
      'SUSHIUPUSDT' : '',
      'SUSHIDOWNUSDT' : '',
      'XLMUPUSDT' : '',
      'XLMDOWNUSDT' : '',
      'GRTUSDT' : 'گراف توکن',
      'JUVUSDT' : 'یونتوی فن توکن',
      'PSGUSDT' : 'پاری سن ژرمن',
      '1INCHUSDT' : '1 اینج',
      'REEFUSDT' : 'ریف فایننس',
      'OGUSDT' : 'او جی فن توکن',
      'ATMUSDT' : 'اتلتیکو مادرید فن توکن',
      'ASRUSDT' : 'آ.اس روم فن توکن',
      'CELOUSDT' : 'سلو',
      'RIFUSDT' : 'آر اس کا اینفراستراکچر',
      'BTCSTUSDT' : 'بیت کوین هش ریت توکن',
      'TRUUSDT' : 'تروفای',
      'CKBUSDT' : '',
      'TWTUSDT' : 'تراست ولت توکن',
      'FIROUSDT' : 'فیرو',
      'LITUSDT' : 'لایت توکن',
      'SFPUSDT' : '',
      'DODOUSDT' : 'دودو',
      'CAKEUSDT' : 'پنکیک سواپ',
      'ACMUSDT' : '',
      'BADGERUSDT' : 'بجر دائو',
      'FISUSDT' : 'استفی',
      'OMUSDT' : '',
      'PONDUSDT' : '',
      'DEGOUSDT' : '',
      'ALICEUSDT' : 'مای نیبرآلیس',
      'LINAUSDT' : '',
      'PERPUSDT' : '',
      'RAMPUSDT' : '',
      'SUPERUSDT' : 'سوپرفارم',
      'CFXUSDT' : 'کانفلاکس نتورک',
      'EPSUSDT' : 'الیپسیس',
      'AUTOUSDT' : '',
      'TKOUSDT' : 'توکوکریپتو',
      'PUNDIXUSDT' : 'پاندی ایکس',
      'TLMUSDT' : '',
      '1INCHUPUSDT' : '',
      '1INCHDOWNUSDT' : '',
      'BTGUSDT' : '',
      'MIRUSDT' : '',
      'BARUSDT' : '',
      'FORTHUSDT' : '',
      'BAKEUSDT' : '',
      'BURGERUSDT' : '',
      'SLPUSDT' : '',
      'SHIBUSDT' : 'شیبا',
      'ICPUSDT' : '',
      'ARUSDT' : 'آرویو',
      'POLSUSDT' : 'پولکا استارتر',
      'MDXUSDT' : '',
      'MASKUSDT' : '',
      'LPTUSDT' : '',
    },
    socket:null
  }),
  watch:{
    convert: function () {
      if(this.crypto.symbol == 'IR' || this.crypto.symbol == 'USDT'){
        this.crypto = {
          symbol : this.crypto_list[0].symbol,
          price : this.crypto_list[0].markPrice
        }
      }
    },
    crypto_search:function() {
      this.crypto_search = this.crypto_search.toUpperCase()
    }
  },
  computed:{
    toman_recieve: function () {
      this.error_text = null
      if(this.amount){

        if(this.crypto.symbol == 'USDT'){
          const number = parseFloat(this.amount) * this.data.buy_price
          return number.toFixed(4)
        }else{
          const price = parseFloat(this.data.buy_price);
          const number = parseFloat(this.amount * parseFloat(this.crypto.price)) * price
          const porsant = number - parseFloat(number * 0.01)
          return porsant.toFixed(5)
        }

      }else{
        return 0;
      }
    },
    buy_crypto_recieve: function () {
      this.error_text = null
      if(this.buy_amount){
        console.log(this.buy_amount);
        return (parseInt(this.buy_amount) / parseFloat(this.data.sale_price)).toFixed(4)
      }else{
        return 0;
      }
    },
  },
  methods:{
    getData () {
      this.$axios.get(`getPrices`)
      .then(res => {
        this.data = res.data.data
      })
      .catch( () => {
      });

    },
  },
  mounted() {
    const vm = this
    this.socket = io(this.socketUrl);

    this.getData()

    vm.socket.on('live_crypto_list', (data) => {
      
      if(Object.keys(vm.crypto_list).length === 0){
        vm.crypto_list = data
        vm.crypto.symbol = vm.crypto_list[0].symbol;
        vm.crypto.price = vm.crypto_list[0].markPrice;
      }

    });
  }
}
</script>
<style scoped>

.under{
  text-decoration: underline;
  cursor: pointer;
}

.yellow-under{
  text-decoration: underline;
  cursor: pointer;
  color: rgb(250, 211, 31);
}

</style>
